import React, { useCallback, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useAuth } from '@/contexts/FirebaseAuthContext';
import MelodyChatbot from '@/components/MelodyChatbot';

/**
 * Single app-wide Melody instance + openMelody listener so Profile > Support, More, notifications, etc.
 * all work on every route (not only inside AdminDashboard).
 */
export default function MelodyGlobalHost() {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [intent, setIntent] = useState(null);

  const clearIntent = useCallback(() => setIntent(null), []);

  useEffect(() => {
    if (!user?.uid) return undefined;

    const handleOpenMelody = (event) => {
      const nextIntent = event?.detail != null ? { ...event.detail } : {};
      flushSync(() => {
        setIntent(nextIntent);
        setIsOpen(true);
      });
    };

    window.addEventListener('openMelody', handleOpenMelody);
    return () => window.removeEventListener('openMelody', handleOpenMelody);
  }, [user?.uid]);

  if (!user?.uid) return null;

  return (
    <MelodyChatbot
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        setIntent(null);
      }}
      intent={intent}
      onIntentHandled={clearIntent}
    />
  );
}
